<script>
  import { createEventDispatcher } from "svelte";

  import { initSchemaValues, _, zObject, isObject } from "./utils.js";

  import Fields from "./fields.svelte";

  export let openapi;
  export let schema;
  export let layout = 'default';
  export let value;
  export let errors = undefined;
  export let apiURL = undefined;
  export let apiMethod = "POST";
  export let apiHeaders = undefined;
  export let apiErrorCallback = undefined;
  export let editable = false;
  export let currentPath = [];
  export let texts = undefined;
  export let extras = undefined;

  export const reset = () => {
    value = initSchemaValues(schema)
    loading = false;
  }

  let form_id;

  let loading = false;
  let validator;

  let msg;

  let canBeSubmitted;
  let dirty;

  $: openapi || schema, loadOpenAPI();
  $: canBeSubmitted = value && validator && (!dirty || Object.keys(dirty).length) ? validator.safeParse(value).success || false : false;

  const loadOpenAPI = async () => {
    if (typeof value === 'string') value = JSON.parse(value);
    if (openapi && schema) {
      if (typeof openapi === 'string') {
        const resp = await fetch(openapi);
        if (resp.ok) openapi = await resp.json();
      }

      if (typeof schema === 'string') schema = openapi.components.schemas[schema];

      if (!currentPath.includes(schema)) currentPath.push(schema);
    }
    if (!validator) validator = zObject(openapi, schema);
    form_id = extras && Object.keys(extras).includes("form_id") ? `${schema.id}_${ extras.form_id }` : schema.id;
  }

  const hasFileChecker = val => {
    if (val instanceof File) return true;
    else if (isObject(val) && hasFiles(val)) return true;
    else if (Array.isArray(val)) {
      for (const item of val) {
        if (hasFileChecker(item)) return true;
      }
    }
    return false
  }

  const hasFiles = obj => {
    for (const val of Object.values(obj)) {
      if (hasFileChecker(val)) return true;
    }
    return false;
  }

  const submit = async () => {
    loading = true;
    if (canBeSubmitted) {
      dispatch('submit', value);
      document.dispatchEvent(new CustomEvent('submit', { detail: value }));
      if (apiURL) {
        if (typeof apiHeaders === 'string') apiHeaders = JSON.parse(apiHeaders);
        if (hasFiles(value)) {
          const formData = new FormData();
          const keys = dirty ? Object.keys(dirty) : Object.keys(schema.properties)
          for (const key of keys) {
            if (Array.isArray(value[key])) {
              for (const item of value[key]) {
                formData.append(`${key}[]`, item);
              }
            } else if (value[key] instanceof File) formData.append(key, value[key]);
            else formData.set(key, value[key]);
          }
          var opts = { method: apiMethod, body: formData }
          if (apiHeaders) opts.headers = apiHeaders;
        } else if (apiMethod.toUpperCase() === "GET") {
          opts = { method: apiMethod }
          if (apiHeaders) opts.headers = apiHeaders;
          const params = new URLSearchParams(value)
          apiURL = `${ apiURL }?${ params.toString() }`;
        } else {
          const headers = { 'Content-type': 'application/json', ...apiHeaders };
          opts = { method: apiMethod, headers, body: JSON.stringify(value) };
        }
        const resp = await fetch(apiURL, opts);
        if (resp.ok) {
          document.dispatchEvent(new CustomEvent('posted', { detail: { form: form_id, schema: schema.id, response: resp } }));
        } else {
          const rjson = await resp.json();
          document.dispatchEvent(new CustomEvent('postError', { detail: { form: form_id, schema: schema.id, error: rjson } }));
          loading = false;
          if (apiErrorCallback) {
            const result = window[apiErrorCallback](openapi, schema, value, errors, resp);
            if (result.value) value = result.value;
            if (result.errors) errors = result.errors;
            if (result.msg) msg = result.msg;
          }
        }
        loading = false;
      }
    } else {
      const ers = {}
      const validates = validator.safeParse(value);
      for(const error of validates.error.issues) {
        if (!Object.keys(ers).includes(error.path[0])) ers[error.path[0]] = [];
        const er = { message: error.message };
        if (error.path.length > 1) er.location = error.path.slice(1);
        ers[error.path[0]].push(er);
      }
      errors = ers;
    }
  }

  const cancel = () => {
    dispatch('cancel');
    document.dispatchEvent(new CustomEvent('cancel', { detail: form_id }));
  }

  const dispatch = createEventDispatcher();
</script>

{#if form_id}
  <form id={ form_id } on:submit|preventDefault|stopPropagation={ submit }>
    {#if errors?.alert_msg}
      <div role="alert" class="alert-errors">
        <i class="bi bi-x-octagon"></i>
        <span>{ errors.alert_msg }</span>
      </div>
    {/if}
    {#if msg?.alert_msg}
      <div role="alert" class="alert-{ msg.type || 'success' }">
        <i class="bi bi-x-octagon"></i>
        <span>{ errors.alert_msg }</span>
      </div>
    {/if}
    <Fields
      { openapi } { schema } { layout } { errors } { editable } { currentPath } { texts } { extras }
      bind:value={ value } bind:canBeSubmitted={ canBeSubmitted } bind:loading={ loading }
      bind:dirty={ dirty }
      on:cancel={ cancel } on:message={ ({ detail }) => { dispatch('message', detail) } }
    >

      <svelte:fragment slot="array-widgets" let:addArrayWidget={ addArrayWidget } let:removeArrayWidget={ removeArrayWidget }>
        <slot name="array-widgets" { addArrayWidget } { removeArrayWidget }></slot>
      </svelte:fragment>
      <svelte:fragment slot="wallet-yours" let:value={ value } let:setValue={ setValue }>
        <slot name="wallet-yours" { value } { setValue } />
      </svelte:fragment>

    </Fields>
  </form>
{:else}
  { _("Loading", texts, "Loading") }
{/if}